/* eslint-disable no-cond-assign */

const escapeRegExp = string => {
  return string.replace(/[.*+?^${}()|[\]]/g, '\\$&');
};

const pageIndexToHighlightIndexes = (startIndex, elemBorders, match) => {
  const endIndex = startIndex + match.length;
  const startElemIndex = elemBorders.findIndex(x => x > startIndex) - 1;
  const endElemIndex = elemBorders.findIndex(x => x > endIndex) - 1;
  const startHighlightIndex = startIndex - elemBorders[startElemIndex];
  const endHighlightIndex = endIndex - elemBorders[endElemIndex];

  const highlights = [];
  for (let i = startElemIndex; i <= endElemIndex; i += 1) {
    highlights.push({
      itemIndex: i,
      highlightStart: i === startElemIndex ? startHighlightIndex : 0,
      highlightEnd: i === endElemIndex ? endHighlightIndex : Infinity,
    });
  }
  return highlights;
};

// TODO: Examine need for escapeRegExp for text, currently only used for searchInput
const searchPageNumber = (elems, searchInput, pageNumber, isCaseSensitive) => {
  const text = elems.join(' '); // TODO: join with space or without
  const elemBorders = elems.reduce(
    (acc, cur) => acc.concat(acc[acc.length - 1] + cur.length + 1),
    [0]
  );
  const regExFlag = isCaseSensitive ? 'g' : 'gi';
  const reg = new RegExp(
    escapeRegExp(searchInput).replace(' ', '\\s+'),
    regExFlag
  );
  const foundMatches = [];
  let hit = reg.exec(text);
  while (hit !== null) {
    foundMatches.push(
      ...pageIndexToHighlightIndexes(hit.index, elemBorders, hit[0])
    );
    // foundMatches.push(pageNumber);
    hit = reg.exec(text);
  }
  if (foundMatches.length === 0) return null;
  return {
    page: pageNumber,
    hits: foundMatches,
  };
};

export const parsePdf = (doc, searchInput, isCaseSensitive) => {
  const maxPages = doc.countPages();
  const foundMatches = [];

  for (let pageNumber = 1; pageNumber <= maxPages; pageNumber += 1) {
    const page = doc.loadPage(pageNumber - 1);
    const stext = page.toStructuredText();

    const elems = [];
    let currentLine = '';
    stext.walk({
      beginLine() { currentLine = ''; },
      onChar(c) { currentLine += c; },
      endLine() { elems.push(currentLine); },
    });

    const result = searchPageNumber(elems, searchInput, pageNumber, isCaseSensitive);
    if (result) foundMatches.push(result);

    stext.destroy();
    page.destroy();
  }

  return foundMatches;
};

const isBrowser = typeof document !== 'undefined';
export function getDevicePixelRatio() {
  return (isBrowser && window.devicePixelRatio) || 1;
}
